import React from 'react';
import { BoolIcon } from '@components/bool.display.styles';

interface BoolDisplayProps {
  value?: boolean;
}

const BoolDisplay = ({ value }: BoolDisplayProps) => {
  return <BoolIcon $on={value}>{value ? 'check_circle' : 'disabled_by_default'}</BoolIcon>;
};

export default BoolDisplay;
